import styled from 'styled-components';
import { PerfectSkeleton } from '../../../../../components/Common/perfect-skeleton/perfect-skeleton.component';
import { THEME } from '../../../../../themes';
import {
  StyledHeader,
  HeaderContainer,
  ContainerBackground,
  HeaderContent,
  ContentContainer,
} from '../homepage-header.styled';
import { HomepageHeaderSkeletonProps } from './homepage-header-skeleton';

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${THEME.SPACING.TINO};
`;

const HomepageHeaderSkeleton = ({
  isHeaderSticky = false,
}: HomepageHeaderSkeletonProps): JSX.Element => {
  return (
    <HeaderContainer>
      <ContainerBackground />
      <StyledHeader isHeaderSticky={ isHeaderSticky } isTrialPlan={ false } />
      <HeaderContent>
        <ContentContainer>
          <PerfectSkeleton width={ 400 } height={ 32 } />
          <PerfectSkeleton width={ 600 } height={ 20 } variant="text" />
        </ContentContainer>
        <RightContainer>
          <PerfectSkeleton width={ 280 } height={ 120 } variant="rounded" />
        </RightContainer>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default HomepageHeaderSkeleton;
